var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-1",
    attrs: {
      "max-width": "1140px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_c('span', [_vm._v("소송 / 분쟁")])]), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("소개글")]), _c('v-card', {
    staticClass: "mt-1"
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.practice.section1.txt,
      callback: function ($$v) {
        _vm.$set(_vm.practice.section1, "txt", $$v);
      },
      expression: "practice.section1.txt"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "mt-8"
  }, [_c('v-layout', {
    attrs: {
      "align-end": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("주요 업무분야")]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }), _c('v-col'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "primary",
      "elevation": "4"
    },
    on: {
      "click": _vm.setItem
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("항목 추가")], 1), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "red",
      "elevation": "4",
      "outlined": ""
    },
    on: {
      "click": _vm.deleteItem
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-delete-outline")]), _vm._v("항목 삭제")], 1)], 1)], 1), _vm._l(_vm.practice.section2, function (section2, index) {
    return _c('div', {
      key: index
    }, [_c('v-divider'), _c('v-card-text', {
      staticClass: "py-0"
    }, [[_c('v-row', {
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: section2.title,
        callback: function ($$v) {
          _vm.$set(section2, "title", $$v);
        },
        expression: "section2.title"
      }
    })], 1), _c('v-col', _vm._l(section2.columns, function (column, index) {
      return _c('v-col', {
        key: index
      }, [_c('v-textarea', {
        attrs: {
          "rows": "1",
          "dense": "",
          "outlined": "",
          "hide-details": ""
        },
        model: {
          value: column.txt,
          callback: function ($$v) {
            _vm.$set(column, "txt", $$v);
          },
          expression: "column.txt"
        }
      })], 1);
    }), 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-col', [_c('v-btn', {
      attrs: {
        "small": "",
        "color": "primary",
        "elevation": "4"
      },
      on: {
        "click": function ($event) {
          return _vm.setColumn(index);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "16"
      }
    }, [_vm._v("mdi-plus")]), _vm._v("행 추가")], 1)], 1), _c('v-col', [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteColumn(index);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "16"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("행 삭제")], 1)], 1)], 1)], 1)]], 2)], 1);
  })], 2)], 1), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-2",
      "elevation": "4"
    },
    on: {
      "click": function ($event) {
        return _vm.save();
      }
    }
  }, [_vm._v("저장")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }